import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

var root_2 = $.from_svg(`<circle r="3" fill="var(--secondary)"></circle>`);
var root_1 = $.from_html(`<div class="trend-container svelte-o549xocdm0v2"><span class="trend-label svelte-o549xocdm0v2"> </span> <svg class="trend-line svelte-o549xocdm0v2"><path fill="none" stroke="var(--secondary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><!></svg></div>`);

function TrendLine($$anchor, $$props) {
	$.push($$props, true);

	let valueKey = $.prop($$props, 'valueKey', 3, 'sessionCount'),
		label = $.prop($$props, 'label', 3, 'Sessions');

	const width = 320;
	const height = 120;
	const padding = { top: 10, right: 10, bottom: 10, left: 10 };
	const chartW = $.derived(() => width - padding.left - padding.right);
	const chartH = $.derived(() => height - padding.top - padding.bottom);
	const values = $.derived(() => $$props.data.map((d) => d[valueKey()]));
	const maxVal = $.derived(() => Math.max(...$.get(values), 1));

	function x(i) {
		if ($$props.data.length <= 1) return $.get(chartW) / 2;

		return i / ($$props.data.length - 1) * $.get(chartW);
	}

	function y(val) {
		return $.get(chartH) - val / $.get(maxVal) * $.get(chartH);
	}

	const linePath = $.derived(() => () => {
		if ($$props.data.length < 2) return '';

		return $$props.data.map((d, i) => `${i === 0 ? 'M' : 'L'} ${padding.left + x(i)} ${padding.top + y(d[valueKey()])}`).join(' ');
	});

	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			var div = root_1();
			var span = $.child(div);
			var text = $.child(span, true);

			$.reset(span);

			var svg = $.sibling(span, 2);

			$.set_attribute(svg, 'viewBox', '0 0 320 120');

			var path = $.child(svg);
			var node_1 = $.sibling(path);

			$.each(node_1, 17, () => $$props.data, $.index, ($$anchor, d, i) => {
				var circle = root_2();

				$.template_effect(
					($0, $1) => {
						$.set_attribute(circle, 'cx', $0);
						$.set_attribute(circle, 'cy', $1);
					},
					[
						() => padding.left + x(i),
						() => padding.top + y($.get(d)[valueKey()])
					]
				);

				$.append($$anchor, circle);
			});

			$.reset(svg);
			$.reset(div);

			$.template_effect(
				($0) => {
					$.set_text(text, label());
					$.set_attribute(path, 'd', $0);
				},
				[() => $.get(linePath)()]
			);

			$.append($$anchor, div);
		};

		$.if(node, ($$render) => {
			if ($$props.data.length > 1) $$render(consequent);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	TrendLine = $.hmr(TrendLine);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-o549xocdm0v2');
		TrendLine[$.HMR].update(module.default);
	});
}

export default TrendLine;
import "bun-svelte:TrendLine.svelte-2fp56h1pfbq8y-style.css";